import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import moment from 'moment';

import LeftPanel from './LeftPanel';
import MainPanel from './MainPanel';
import EditSiteDetails from './EditSiteDetails';

import { tableDataMapper } from '../utils';
import { SEGMENT, DATE_FORMATS } from '../constants';
import { fetchOrderDetailsAsync, fetchRuntimeConfigAsync, updateOrderDetailsAsync } from '../services';

import './index.scss';
import { GENERIC_ERROR_MESSAGE, ROUTES } from 'common/constants/app.constants';
import { findParamFromUrl, trackAnalytics } from 'common/utils/app.utils';
import { NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';
import { paginationLength } from 'rateCard/constant/constant';

const OrderDetailComponent = (props) => {
  const history = useHistory();
  const DATE_TODAY = new Date();
  const DATE_AFTER_1_MONTH = new Date(new Date().getUTCFullYear(), new Date().getUTCMonth() + 1, new Date().getUTCDay());

  const MOCK_PARAMS_ENTERPRISE = {
    media: 'FTTH',
    appointmentStartDate: moment(DATE_TODAY).format(DATE_FORMATS.YYYY_MM_DD), //'2023-11-11'
    appointmentEndDate: moment(DATE_AFTER_1_MONTH).format(DATE_FORMATS.YYYY_MM_DD), //'2023-11-11'
    pincode: '122001',
    segment: SEGMENT.ENTERPRISE,
    orderType: 'NEW',
    orderSubType: 'NEW',
    rsuCode: 'PDG'
  };

  const [sitesData, setSitesData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [showEditSiteDetailsModal, setShowEditSiteDetailsModal] = useState(false);
  const [selectedLineItem, setSelectedLineItem] = useState({});
  const [loader, showLoader] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', hideNotificaton: false, type: NOTIFICATION_TYPE.SUCCESS });
  const [records, setRecords] = useState({ content: [], totalElement: 0, totalPages: 0 });
  const [config, setConfig] = useState({});
  const [lineItemRecords, setLineItemRecords] = useState(null);
  const handleLineItemClick = (e, lineItemRecord) => {
    const data = history && history.location && history.location.state && history.location.state.orderData;
    e.preventDefault();
    setSelectedLineItem(lineItemRecord);
    setLineItemRecords(lineItemRecord);
    setShowEditSiteDetailsModal(true);
    trackAnalytics({
      eVar9: `b2b|edl|${data && data.product}|buy|site readiness|edit details`,
      prop0: `b2b|edl|${data && data.customerSegment}|${data && data.product}`,
      prop15: data && data.cpmEmail,
      prop17: data && `${data.cpmFirstName} ${data.cpmLastName}`,
      prop14: data && data.cpmPhoneNumber,
      prop35: data && data.accountName,
      prop39: data && data.customerSegment,
      prop40: data && data.product,
      prop37: lineItemRecord && lineItemRecord.orderType,
      prop43: data && data.sites && data.sites.length,
      prop9: lineItemRecord && lineItemRecord.pincode,
      prop36: data && data.accountName,
      prop20: lineItemRecord && lineItemRecord.installationAddress,
      prop10: data && data.orderId,
      prop29: lineItemRecord && lineItemRecord.media,
      prop16: lineItemRecord && lineItemRecord.city,
      prop7: lineItemRecord && `${lineItemRecord.dcpFirstName} ${lineItemRecord.dcpLastName}`,
      prop8: lineItemRecord && lineItemRecord.dcpPhoneNumber,
      prop9: lineItemRecord && lineItemRecord.dcpEmail,
      prop37: lineItemRecord && lineItemRecord.customerNeedByDate,
      prop14: 'yes',
      prop11: `${data && data.cpmFirstName} ${data && data.cpmLastName}`,
      prop12: data && data.cpmPhoneNumber,
      prop13: data && data.cpmEmail
    });
  };

  const fetchConfigDetails = async () => {
    try {
      showLoader(true);

      const res = await fetchRuntimeConfigAsync();

      if (res?.status === 200) {
        showLoader(false);
        const data = res?.data?.result;
        setConfig(data);
      }
    } catch (error) {
      showLoader(false);

      if (error?.response?.status === 401) {
        history?.push(`${ROUTES.EXPRESS_DELIVERY_PAGE_LOGIN}?orderId=${findParamFromUrl('orderId')}`);
      } else {
        const errorMsg = (error && error.response && error.response.data && error.response.data.status && error.response.data.status.message) || GENERIC_ERROR_MESSAGE;
        setNotification({ show: true, message: errorMsg, type: NOTIFICATION_TYPE.ERROR });
      }
    }
  };

  const fetchOrderDetails = async (params) => {
    try {
      showLoader(true);
      const defaultParams = {
        page: 1,
        size: 10,
        ...params
      };

      const res = await fetchOrderDetailsAsync(defaultParams);
      if (res?.status === 200) {
        showLoader(false);
        const data = res?.data?.result;
        const parsedData = tableDataMapper(data, handleLineItemClick);
        setSitesData(data);
        setTableData(parsedData);

        const recordsCpy = res?.data?.result;

        if (!recordsCpy?.totalPages && !recordsCpy?.totalElement) {
          recordsCpy.totalElement = res?.data?.result?.sites?.length;
          recordsCpy.totalPages = Math.ceil(recordsCpy.totalElement / paginationLength);
        }

        setRecords(recordsCpy);
      }
    } catch (error) {
      showLoader(false);

      if (error?.response?.status === 401) {
        history?.push(`${ROUTES.EXPRESS_DELIVERY_PAGE_LOGIN}?orderId=${findParamFromUrl('orderId')}`);
      } else {
        const errorMsg = (error && error.response && error.response.data && error.response.data.status && error.response.data.status.message) || GENERIC_ERROR_MESSAGE;
        setNotification({ show: true, message: errorMsg, type: NOTIFICATION_TYPE.ERROR });
      }
    }
  };

  const getPostRequestData = (updatedSitesData) => {
    const updatedSitesDataCpy = JSON.parse(JSON.stringify(updatedSitesData));
    updatedSitesDataCpy.sites = updatedSitesDataCpy.sites.filter((item) => item.lsiId === selectedLineItem?.lsiId);
    if (!updatedSitesDataCpy.sites[0].siteReadinessStatus) {
      updatedSitesDataCpy.sites[0].appointmentDate = null;
      updatedSitesDataCpy.sites[0].appointmentStartTime = null;
      updatedSitesDataCpy.sites[0].appointmentEndTime = null;
      updatedSitesDataCpy.sites[0].appointmentId = null;
    } else {
      updatedSitesDataCpy.sites[0].siteReadinessDate = null;
    }

    return updatedSitesDataCpy;
  };

  const handleSubmit = async (updatedSitesData) => {
    try {
      showLoader(true);
      const requestData = getPostRequestData(updatedSitesData || sitesData);
      const res = await updateOrderDetailsAsync(requestData);
      if (res?.status === 200) {
        showLoader(false);
        fetchOrderDetails();
        setShowEditSiteDetailsModal(false);
        setNotification({ show: true, message: 'Changes Saved Successfully.', type: NOTIFICATION_TYPE.SUCCESS });
        trackAnalytics({
          eVar0: `b2b|edl|${updatedSitesData.product}|buy|site readiness|edit details|saved successfully`,
          prop0: `b2b|edl|${updatedSitesData.customerSegment}|${updatedSitesData.product}`,
          prop15: updatedSitesData && updatedSitesData.cpmEmail,
          prop17: updatedSitesData && `${updatedSitesData.cpmFirstName} ${updatedSitesData.cpmLastName}`,
          prop14: updatedSitesData && updatedSitesData.cpmPhoneNumber,
          prop35: updatedSitesData && updatedSitesData.accountName,
          prop39: updatedSitesData && updatedSitesData.customerSegment,
          prop40: updatedSitesData && updatedSitesData.product,
          prop37: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites[0].orderType,
          prop43: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites.length,
          prop9: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites && updatedSitesData.sites[0].pincode,
          prop36: updatedSitesData && updatedSitesData.accountName,
          prop20: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites && updatedSitesData.sites[0].installationAddress,
          prop10: updatedSitesData && updatedSitesData.orderId,
          prop29: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites[0].media,
          prop16: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites[0].city,
          prop7: updatedSitesData && updatedSitesData.sites && `${updatedSitesData.sites[0].dcpFirstName} ${updatedSitesData.sites[0].dcpLastName}`,
          prop8: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites[0].dcpPhoneNumber,
          prop9: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites[0].dcpEmail,
          prop37: updatedSitesData && updatedSitesData.sites && updatedSitesData.sites[0].customerNeedByDate,
          prop14: 'yes',
          prop11: updatedSitesData && `${updatedSitesData.cpmFirstName} ${updatedSitesData.cpmLastName}`,
          prop12: updatedSitesData && updatedSitesData.cpmPhoneNumber,
          prop13: updatedSitesData && updatedSitesData.cpmEmail
        });
      } else if (res?.status === 401) {
        history?.push(`${ROUTES.EXPRESS_DELIVERY_PAGE_LOGIN}?orderId=${findParamFromUrl('orderId')}`);
      }
    } catch (error) {
      showLoader(false);
      if (error?.response?.status === 401) {
        history?.push(`${ROUTES.EXPRESS_DELIVERY_PAGE_LOGIN}?orderId=${findParamFromUrl('orderId')}`);
      } else {
        const errorMsg = (error && error.response && error.response.data && error.response.data.status && error.response.data.status.message) || GENERIC_ERROR_MESSAGE;
        setNotification({ show: true, message: errorMsg, type: NOTIFICATION_TYPE.ERROR });
      }
    }
  };
  useEffect(() => {
    fetchConfigDetails();
    let data = history && history.location && history.location.state && history.location.state.orderData;
    const installationAddressess = data?.sites?.map((item) => item.installationAddress).join(', ');
    const orderTypes = data?.sites.map((item) => item.orderType).join(', ');
    const mediaTypes = data?.sites?.map((item) => item.media).join(', ');
    const cities = data?.sites?.map((item) => item.city).join(', ');
    const siteContactDetailsFullNames = data?.sites?.map((item) => `${item.dcpFirstName} ${item.dcpLastName}`).join(', ');
    const siteContactDetailsMobileNumbers = data?.sites?.map((item) => item.dcpPhoneNumber).join(', ');
    const siteContactDetailsEmails = data?.sites?.map((item) => item.dcpEmail).join(', ');
    const pincodes = data?.sites?.map((item) => item.pincode).join(', ');
    const customerNeedByDates = data?.sites?.map((item) => item.customerNeedByDate).join(', ');
    trackAnalytics({
      eVar0: `b2b|edl|${data && data.product}|buy|site readiness`,
      prop0: `b2b|edl|${data && data.customerSegment}|${data && data.product}`,
      prop15: data && data.cpmEmail,
      prop17: data && `${data.cpmFirstName} ${data.cpmLastName}`,
      prop14: data && data.cpmPhoneNumber,
      prop35: data && data.accountName, //account selected????????????
      prop39: data && data.customerSegment, //segment
      prop40: data && data.product, //product type
      prop37: orderTypes || '', //type of order
      //prop38: order nickname,
      // prop41:<type of site>,
      prop43: data && data.sites && data.sites.length, //no. of sites
      // prop21:<feasibility request id>,
      // Prop23:<link id>,
      prop9: pincodes || '', //pincode
      prop36: data && data.accountName, //company name???????????????
      prop20: installationAddressess || '', //installation address
      // Prop26:<bandwidth>,
      // Prop28:<site type>,
      prop10: data && data.orderId, //order request id
      prop29: mediaTypes || '', //media type
      // Prop22:<contract period>,
      // Prop18:<total amount>,
      // Prop1:<purchase order number>,
      // Prop24:<purchase order>,
      // Prop25:<purchase order till>,
      // Prop2:<purchase order amount>,
      // Prop3:<payment type>,
      // Prop4:<payment cycle>,
      // Prop5:<account number>,
      // prop6:<account number>,
      prop16: cities || '', //city
      prop7: siteContactDetailsFullNames || '', //full name of site contact details
      prop8: siteContactDetailsMobileNumbers || '', //mobile number of site contact details
      prop9: siteContactDetailsEmails || '', //email address of site contact details
      prop37: customerNeedByDates || '', //customer need by date
      // Prop38:<gstin>,
      // Prop14:yes,
      prop11: `${data && data.cpmFirstName} ${data && data.cpmLastName}`, //full name of cpm
      prop12: data && data.cpmPhoneNumber, //cpm mobile no.
      prop13: data && data.cpmEmail //cpm email
    });

    if (data && Object.keys(data).length > 0) {
      const parsedData = tableDataMapper(data, handleLineItemClick);
      setSitesData(data);
      setTableData(parsedData);
    } else {
      fetchOrderDetails();
    }
  }, []);

  return (
    <Fragment>
      {showEditSiteDetailsModal && lineItemRecords && (
        <EditSiteDetails
          open={showEditSiteDetailsModal}
          setOpen={setShowEditSiteDetailsModal}
          sitesData={sitesData}
          setSitesData={setSitesData}
          selectedLineItem={selectedLineItem}
          onSubmitClick={handleSubmit}
          fetchOrderDetails={fetchOrderDetails}
          notification={notification}
          setNotification={setNotification}
          loader={loader}
          config={config}
          lineitems={lineItemRecords}
        />
      )}
      <div className="order-details-container">
        <LeftPanel sitesData={sitesData} />
        <MainPanel tableData={tableData} loader={loader} notification={notification} setNotification={setNotification} records={records} fetchOrderDetails={fetchOrderDetails} />
      </div>
    </Fragment>
  );
};

export default OrderDetailComponent;
